/**
 * Http Client Interceptor to being able to listen to each call
 */
// Angular
import { Injector, Injectable } from '@angular/core';
import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
// State
import { Store } from '@ngxs/store';
// Services
import { BroadcastService } from '../service/broadcast.service';
import { RoleService } from '../service/role.services';
import { AppService } from '../service/app.service';
import { ConnectionService } from 'ng-connection-service';
import { ObjectUtils } from '../utils/object.utils';
import { AppInformationService } from '../service/app-info.service';
import { ErrorFactoryService } from '../service/error-factory.service';
// Models
import { HttpRequestModel } from '../model/http-request.model';
// Other
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const SKIP_AUTH_HEADER = 'SKIP_AUTH_HEADER';

@Injectable()
export class HttpRequestInterceptor extends HttpRequestModel implements HttpInterceptor {

	constructor(
		protected router: Router,
		private injector: Injector,
		protected store: Store,
		protected errorFactoryService: ErrorFactoryService,
		protected connectionService: ConnectionService,
		protected broadcastService: BroadcastService,
		protected roleService: RoleService,
		protected appService: AppService,
		protected appInfo: AppInformationService
	) {
		super(router, connectionService, broadcastService, roleService, errorFactoryService, appInfo, appService);
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const skipHandler = ObjectUtils.containsPattern(request.url, this.appService.getHandledByOtherExceptions());
		if (skipHandler) {
			return next.handle(request);
		}

		return this.handleRequest(request, next);
	}

	/**
	 * Capture the current request and performs some validations
	 * @param request
	 * @param next
	 */
	protected handleRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			map((event: HttpEvent<any>) => this.onSuccessRequest(event)),
			catchError((err: HttpErrorResponse) => this.onErrorRequest(err))
		);
	}
}

/**
 * Factory function to help the dependency injection
 * @param store
 *
 * @param broadcastService
 * @constructor
 */
export function HTTPFactory(
	store: Store,
	broadcastService: BroadcastService,
	roleService: RoleService,
	errorFactoryService: ErrorFactoryService,
	injector: Injector,
	connectionService: ConnectionService,
	router: Router,
	appService: AppService,
	appInfo: AppInformationService
): HttpRequestInterceptor {
	return new HttpRequestInterceptor(
		router,
		injector,
		store,
		errorFactoryService,
		connectionService,
		broadcastService,
		roleService,
		appService,
		appInfo
	);
}
